import './Footer.style.css';
import { ReactComponent as Logo } from '../../assets/logo.svg';

const Footer = () => {
	return (
		<footer className="footer">
			<div className="footer-wrapper">
				<div className="logo">
					<Logo />
					<span>Nasjonalbiblioteket</span>
				</div>
				<div>
					<hr />
					<div>
						<div>
							<h3 id="apningstider">Åpningstider:</h3>

							<p>Mandag-fredag kl. 09.00-21.00</p>

							<p>Lørdag kl. 10.00-18.00</p>

							<div
								data-style="height: 2.5rem"
								aria-hidden="true"
							></div>
							<p>
								<a href="/apningstider/">
									Les mer om åpningstider og tilbud
								</a>
							</p>
						</div>

						<div>
							<h3 id="besoksadresser">Besøksadresse</h3>

							<p>
								<a href="https://www.google.no/maps/place/Nasjonalbiblioteket/@59.9139308,10.7154816,17z/data=!3m1!4b1!4m5!3m4!1s0x46416c2b317e5fa1:0x99daeff36858a72d!8m2!3d59.9139308!4d10.7176703">
									Henrik Ibsens gate 110, Oslo
								</a>
							</p>

							<p>
								<a href="https://www.google.no/maps/place/Finsetveien%202,%208624%20Mo%20i%20Rana">
									Finsetveien 2, Mo i Rana
								</a>
							</p>
						</div>

						<div>
							<h3 id="besoksadresser">Kontaktinformasjon:</h3>

							<p>
								E-post: <a href="mailto:nb@nb.no">nb@nb.no</a>
							</p>

							<p>
								Telefon: <a href="tel:23276000">23 27 60 00</a>
							</p>
						</div>

						<div>
							<h3 id="besoksadresser">Sosiale medier</h3>
							<ul>
								{/* wp:social-link { "url":"https://www.facebook.com/nasjonalbiblioteket/","service":"facebook"}

								wp:social-link { "url":"https://twitter.com/search?q=nasjonalbiblioteket","service":"twitter"}

								wp:social-link { "url":"https://www.instagram.com/nasjonalbiblioteket/","service":"instagram"}  */}
							</ul>
						</div>
					</div>

					<hr />

					<h3 id="snarveier">Snarveier:</h3>

					<div className="shortcuts">
						<div>
							<p>
								<a href="https://sporbiblioteket.nb.no/">
									Spør Nasjonalbiblioteket
								</a>
							</p>

							<p>
								<a href="/om-nb/ledige-stillinger/">
									Ledige stillinger
								</a>
							</p>

							<p>
								<a href="/standardnummerering/">
									Standardnummerering
								</a>
							</p>
						</div>

						<div>
							<p>
								<a href="/om-nb/kontaktadresser/">
									Adresseoversikt
								</a>
							</p>

							<p>
								<a href="/hjelp-og-informasjon/">
									{' '}
									Hjelp og informasjon
								</a>
							</p>
						</div>

						<div>
							<p>
								<a href="/om-nb/presse/">Presse</a>
							</p>

							<p>
								<a href="https://einnsyn.no/sok?stat0=http%3A%2F%2Fdata.einnsyn.no%2Fvirksomhet%2Foepeksport_content_provider_126">
									Offentlig postjournal
								</a>
							</p>
						</div>

						<div>
							<p>
								<a href="/om-nb/">Om oss</a>
							</p>

							<p>
								<a href="/pliktavlevering/">Pliktavlevering</a>
							</p>
						</div>
					</div>

					<hr />

					<div>
						<div>
							<p>Ansvarlig redaktør: Aslak Sira Myhre</p>
						</div>

						<div>
							<p>Organisasjonsnummer: 976 029 100</p>
						</div>

						<div>
							<p>
								<a href="/personvernerklaering/">
									Personvernerklæring
								</a>
							</p>
						</div>
						<div>
							<p></p>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
